import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const BookTitleSectionOuter = styled.div`
    & > div > div, & > div > textarea {
        font-size: 30px !important;
        font-weight: 500 !important;
        line-height: 40px !important;
        letter-spacing: -0.02em !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        & > div > div, & > div > textarea {
            font-size: 23px !important;
            line-height: 29px !important;
        }
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding-top: 16px;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding-top: 16px;
        & > div > div, & > div > textarea {
            font-size: 22px !important;
            line-height: 28px !important;
        }
    }
`;

export const ProjectEditPageGridInput = styled(FlexBox)<{ visible?: boolean, isTopLink?: boolean, isTeamEdit?: boolean, isColumns?: boolean, largePadding?: boolean, isCheckbox?: boolean, isLMSEdit?: boolean, isPresentation?: boolean }>`
    width: 100%;
    position: relative;

    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #909090;
    }

    input[type=time] {
        background-color: #f2f2f2;
        border-color: transparent;
        color: #151514;
    }

    .brg-input__value-container {
        height: 100%;
    }
    
    .phone-input-button {
        border: none;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        div {
            min-width: auto;
        }
    }

    .brg-input__control--menu-is-open {
        .brg-input__value-container {
            height: auto;
        }
    }
        
    .brg-input__control {
        background-color: rgba(242, 242, 242, 1) !important;
        border-color: transparent !important;

            .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090 !important;
                }
            }

    }

    .brg-input__multi-value__label, .brg-input__single-value  {
        color: #151514 !important;
    }

    .brg-input__multi-value {
        background-color: transparent;
        padding-top: 8px;
        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__multi-value__remove {
        cursor: pointer;
        &:hover {
            background-color: transparent;
        }
    }

    .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }

      .brg-input__indicators {
        align-items: start;
      }
      
      .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
      }

    input {
        ${({ largePadding }) => largePadding && css`
            padding-right: 50px;
        `};
    }

    .showcase-switcher {
        margin: auto 0 0 0;
    }

    ${({ visible }) => visible ? css`
        display: none;
    ` : null};

    ${({isTeamEdit, isPresentation, isLMSEdit}) => !isTeamEdit && css`
        .ui-input_container {
            background-color: ${( isPresentation || isLMSEdit) ? '#fefefe' : Colors.galBlack5} !important;       
            color: ${Colors.galBlack47} !important;
            &::placeholder {
                color: ${Colors.galBlack47} !important;
            }
        }
    `}

    

    ${({ isTeamEdit, isColumns, isCheckbox, isLMSEdit, isTopLink }) => (isLMSEdit || isTeamEdit) ? css`
        width: 100%;

        .checkbox {
            width: 26.5px;
            height: 26.5px;
            min-width: 26.5px;
            // padding: 12px 0 12px 0 !important;

            :hover {
                background-color: transparent;
            }

        }

        button {
            border: 1px solid #545453;
            border-radius: 3px;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;
            text-align: center;
            letter-spacing: -0.02em;
            height: 36px;
            width: 181px;
            max-width: 181px;
            cursor: pointer;
            outline: transparent;
            background-color: #F2F2F2;
            color: #151514;

            &:focus {
                outline: transparent;
            }
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            input {
                height: 40px;
            }
            .brg-input__control {
                height: 40px !important;
            }
        }

        @media(max-width: ${LayoutConst.screen.l}px) {
            width: ${isCheckbox ? 'auto' : '100%'} !important;
        }

        @media(max-width: ${LayoutConst.screen.s}px) {
            button {
                font-size: 13px;
                line-height: 16px;
            }

          }
    
    ` : null};
  
      ${({ isLMSEdit }) => (isLMSEdit) ? css`
        width: 100%!important;
        max-width: none!important;

        @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        }

        @media (max-width: ${LayoutConst.screen.m}px) {
          width: 100%!important;
          max-width: none!important;
        }

      ` : null}

    input[type="checkbox"] {
        height: auto !important;
        width: auto !important;
    }

    &>div:not(.checkbox) {
        width: 100%;
    }
`;


export const ProjectEditPageGridList = styled(FlexBox)<{ visible?: boolean, isTeamEdit?: boolean }>`
    width: 100%;

    .checkbox {
        &:hover {
            background-color: transparent !important;
        }
    }

    ${({ visible }) => visible ? css`
        display: none;
    ` : null};

    input, textarea {
        background-color: ${Colors.galBlack5} !important;
        border-color: transparent !important;
        color: ${Colors.galBlack47} !important;

        &:hover {
            border-color: transparent !important;
        }

        &::placeholder {
            color: ${Colors.galBlack47} !important;
        }
    }

    button {
        width: 159px;
        height: 36px;
        border: 1px solid #545453;
        border-radius: 3px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #151514;
        display: flex;
        flex-flow: row;
        place-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            margin-right: 12px;
        }

        svg path {
            fill: #151514;
        }
    }

    input[type="checkbox"] {
        height: auto !important;
        width: auto !important;
    }

    &>div {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        button {
            width: auto;
            min-width: 107px;
            max-width: 159px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        ${({ isTeamEdit }) => isTeamEdit ? css`
            .checkbox {
                width: 24px;
                padding: 0;
            }

            svg {
                margin-left: 0px !important
            }
            
            button {
                font-size: 13px !important;
                line-height: 16px !important;
            }
        ` : null};
    }
`

export const BookEditAddTagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  [data-tip] {
    pointer-events: none;
  }

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    // max-width: 293px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    max-width: 100%;
  }
`

export const BookAddTagText = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const DatePickerTeamWrapper = styled.div<{formEdit?: boolean}>`
    width: ${({formEdit}) => formEdit ? '320px' : '100%'};

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  .react-datetime-picker__inputGroup__leadingZero, .react-datetime-picker__inputGroup__divider {
    color: #151514;
  }
  .react-datetime-picker__inputGroup__input {
    height: auto;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const BookTitleSectionOuter = styled.div`
    & > div > div, & > div > textarea {
        font-size: 30px !important;
        font-weight: 500 !important;
        line-height: 40px !important;
        letter-spacing: -0.02em !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        & > div > div, & > div > textarea {
            font-size: 23px !important;
            line-height: 29px !important;
        }
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding-top: 16px;
    }
    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding-top: 16px;
        & > div > div, & > div > textarea {
            font-size: 22px !important;
            line-height: 28px !important;
        }
    }
`;

export const ProjectEditPageGridInput = styled(FlexBox)<{ visible?: boolean, isTopLink?: boolean, isTeamEdit?: boolean, isColumns?: boolean, largePadding?: boolean, isCheckbox?: boolean, isLMSEdit?: boolean, isPresentation?: boolean }>`
    width: 100%;
    position: relative;

    .text {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        color: #909090;
    }

    input[type=time] {
        background-color: #f2f2f2;
        border-color: transparent;
        color: #151514;
    }

    .brg-input__value-container {
        height: 100%;
    }
    
    .phone-input-button {
        border: none;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }

        div {
            min-width: auto;
        }
    }

    .brg-input__control--menu-is-open {
        .brg-input__value-container {
            height: auto;
        }
    }
        
    .brg-input__control {
        background-color: rgba(242, 242, 242, 1) !important;
        border-color: transparent !important;

            .brg-input__placeholder {
                color: #909090;
            }
            &:focus {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:active {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090;
                }
            }
            &:hover {
                border-color: #30363A;
                .brg-input__placeholder {
                    color: #909090 !important;
                }
            }

    }

    .brg-input__multi-value__label, .brg-input__single-value  {
        color: #151514 !important;
    }

    .brg-input__multi-value {
        background-color: transparent;
        padding-top: 8px;
        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__multi-value__remove {
        cursor: pointer;
        &:hover {
            background-color: transparent;
        }
    }

    .brg-input__menu-list {
        &::-webkit-scrollbar {
          height: 1px;
          width: 2px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        &::-webkit-scrollbar-thumb {
          background: ${({theme}) => theme.competition.input.inputText} !important;
        }
      }
    
      .brg-input__menu {
        background-color: ${({theme}) => theme.competition.input.bg} !important;
    
        .brg-input__option {
          cursor: pointer;
          color: ${({theme}) => theme.competition.input.inputText} !important;
          svg {
            path {
              fill: ${({theme}) => theme.competition.input.inputText} !important;
            }
          }
        }
        .brg-input__option--is-focused {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
        .brg-input__option--is-focused:hover {
          background-color: ${({theme}) => theme.competition.input.bgActive} !important;
        }
      }

      .brg-input__indicators {
        align-items: start;
      }
      
      .brg-input__indicator {
        padding-top: 14px;
        margin-right: 0;
        svg {
          path {
            fill: ${({theme}) => theme.competition.input.inputText} !important;;
          }
        }
      }

    input {
        ${({ largePadding }) => largePadding && css`
            padding-right: 50px;
        `};
    }

    .showcase-switcher {
        margin: auto 0 0 0;
    }

    ${({ visible }) => visible ? css`
        display: none;
    ` : null};

    ${({isTeamEdit, isPresentation, isLMSEdit}) => !isTeamEdit && css`
        .ui-input_container {
            background-color: ${( isPresentation || isLMSEdit) ? '#fefefe' : Colors.galBlack5} !important;       
            color: ${Colors.galBlack47} !important;
            &::placeholder {
                color: ${Colors.galBlack47} !important;
            }
        }
    `}

    

    ${({ isTeamEdit, isColumns, isCheckbox, isLMSEdit, isTopLink }) => (isLMSEdit || isTeamEdit) ? css`
        width: 100%;

        .checkbox {
            width: 26.5px;
            height: 26.5px;
            min-width: 26.5px;
            // padding: 12px 0 12px 0 !important;

            :hover {
                background-color: transparent;
            }

        }

        button {
            border: 1px solid #545453;
            border-radius: 3px;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;
            text-align: center;
            letter-spacing: -0.02em;
            height: 36px;
            width: 181px;
            max-width: 181px;
            cursor: pointer;
            outline: transparent;
            background-color: #F2F2F2;
            color: #151514;

            &:focus {
                outline: transparent;
            }
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            input {
                height: 40px;
            }
            .brg-input__control {
                height: 40px !important;
            }
        }

        @media(max-width: ${LayoutConst.screen.l}px) {
            width: ${isCheckbox ? 'auto' : '100%'} !important;
        }

        @media(max-width: ${LayoutConst.screen.s}px) {
            button {
                font-size: 13px;
                line-height: 16px;
            }

          }
    
    ` : null};
  
      ${({ isLMSEdit }) => (isLMSEdit) ? css`
        width: 100%!important;
        max-width: none!important;

        @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        }

        @media (max-width: ${LayoutConst.screen.m}px) {
          width: 100%!important;
          max-width: none!important;
        }

      ` : null}

    input[type="checkbox"] {
        height: auto !important;
        width: auto !important;
    }

    &>div:not(.checkbox) {
        width: 100%;
    }
`;


export const ProjectEditPageGridList = styled(FlexBox)<{ visible?: boolean, isTeamEdit?: boolean }>`
    width: 100%;

    .checkbox {
        &:hover {
            background-color: transparent !important;
        }
    }

    ${({ visible }) => visible ? css`
        display: none;
    ` : null};

    input, textarea {
        background-color: ${Colors.galBlack5} !important;
        border-color: transparent !important;
        color: ${Colors.galBlack47} !important;

        &:hover {
            border-color: transparent !important;
        }

        &::placeholder {
            color: ${Colors.galBlack47} !important;
        }
    }

    button {
        width: 159px;
        height: 36px;
        border: 1px solid #545453;
        border-radius: 3px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #151514;
        display: flex;
        flex-flow: row;
        place-items: center;
        justify-content: center;
        cursor: pointer;

        svg {
            margin-right: 12px;
        }

        svg path {
            fill: #151514;
        }
    }

    input[type="checkbox"] {
        height: auto !important;
        width: auto !important;
    }

    &>div {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        button {
            width: auto;
            min-width: 107px;
            max-width: 159px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        ${({ isTeamEdit }) => isTeamEdit ? css`
            .checkbox {
                width: 24px;
                padding: 0;
            }

            svg {
                margin-left: 0px !important
            }
            
            button {
                font-size: 13px !important;
                line-height: 16px !important;
            }
        ` : null};
    }
`

export const BookEditAddTagsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  [data-tip] {
    pointer-events: none;
  }

  .tags-wrapper-grid-block {
    max-width: 100%;
    margin-left: 0;

    * {
      margin-left: 0;
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    // max-width: 293px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    max-width: 100%;
  }
`

export const BookAddTagText = styled.div`
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    text-align: left;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const DatePickerTeamWrapper = styled.div<{formEdit?: boolean}>`
    width: ${({formEdit}) => formEdit ? '320px' : '100%'};

  .date-input {
    width: 100%!important;
    max-width: 100% !important;
  }

  .react-datetime-picker__inputGroup__leadingZero, .react-datetime-picker__inputGroup__divider {
    color: #151514;
  }
  .react-datetime-picker__inputGroup__input {
    height: auto;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`